export default __webpack_public_path__ + "static/media/onimg.19e354b1.png";